import { useState } from 'react';

import { useRetailerCase } from 'pages/qa-spec/hooks/useRetailerCase';
import { EDIT_SECTION } from 'pages/qa-spec/components/edit-tab-checker';

import { useGetQaPhysicalChemicalSnapshot } from '../qa-prod-spec/snapshot/hooks';
import PackagingGrid from '../qa-prod-spec/PackagingGrid';
import { Typography, Row, Col } from 'antd';

const { Text } = Typography;

const RetailerUnit = (props) => {
  const { productId, enumOptions } = props;

  const [isGridEditing, setIsGridEditing] = useState(false);

  const {
    gridInst,
    analysisNotExecuted, // TODO: Update it to analysisExecuted.
    rowData,
    columnDefs,
    saveData,
    cancelEdit,
    loading,
    addNewRow,
    deleteData,
    selectedRow,
    selectRow,
    onCellEditingStopped,
    gridTitle,
  } = useRetailerCase({
    productId,
    enumOptions,
    isGridEditing,
  });

  const { physicalChemicalSnapshot, analysisNotExecutedSnapshot } =
    useGetQaPhysicalChemicalSnapshot();

  const onEdit = (isEditing) => {
    setIsGridEditing(isEditing);
  };

  return (
    <PackagingGrid
      type={EDIT_SECTION.QA_PACKAGING_EPR}
      title={gridTitle}
      loading={loading}
      gridInst={gridInst}
      columnDefs={columnDefs}
      rowData={rowData}
      handleSave={saveData}
      handleAdd={addNewRow}
      handleDelete={deleteData}
      handleCancel={cancelEdit}
      selectedRow={selectedRow}
      onRowSelected={selectRow}
      analysisNotExecuted={analysisNotExecuted}
      analysisNotExecutedSnapshot={analysisNotExecutedSnapshot}
      isShowAnalysisNotExecuted={false}
      productId={productId}
      onCellEditingStopped={onCellEditingStopped}
      snapshotGridValues={physicalChemicalSnapshot}
      onEditChange={onEdit}
      fieldPathTooltip='qaSpecification.productSpecification.analysisNotExecuted2'
      isShowSubtitle={true}
      subtitle={
        <Text>
          List all materials that make up the packaging component
          <Text strong> (i.e. Empty glass, Foil sleeve)</Text> as retail unit level.
          If product contains multiple packaging components, click on the <Text strong>"Add"</Text> button to add multiple rows.
        </Text>
      }
    />
  );
};

export default RetailerUnit;
